/*
 * INTEX CUSTOM — not part of vanilla Ignite. See INTEX-CHANGES.md §14.54.
 *
 * Gives each "Fits [name]" badge a title holding its full text, so a name
 * that assets/intex-compat-badge.css cuts off with an ellipsis can still be
 * read on hover.
 *
 * Benchmark's assets/compatibility-badge.js fills the name in by rewriting a
 * text node and reveals the badge by toggling `hidden`, and it can do either
 * again later (the shopper renames, adds or removes a saved model). Rather
 * than edit that file, one observer watches for exactly those two changes and
 * re-reads the text, so the title can never go stale. It also catches badges
 * on cards added later (filtering, infinite scroll, recommendations).
 */
(() => {
  const FLAG = '__intexCompatBadgeBound';

  if (window[FLAG]) return;
  window[FLAG] = true;

  function sync(badge) {
    badge.querySelectorAll('.notification-message--compat').forEach(message => {
      const text = message.textContent.replace(/\s+/g, ' ').trim();

      /* While the name is still the [name] placeholder, a title would only
         show the template. */
      if (!text || text.includes('[name]')) {
        message.removeAttribute('title');
      } else if (message.title !== text) {
        message.title = text;
      }
    });
  }

  function syncAll(root) {
    if (root.matches?.('compatibility-badge')) sync(root);
    root.querySelectorAll?.('compatibility-badge').forEach(sync);
  }

  const observer = new MutationObserver(records => {
    const badges = new Set();

    records.forEach(record => {
      if (record.type === 'childList') {
        record.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) syncAll(node);
        });
      }

      const element = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
      const badge = element?.closest('compatibility-badge');
      if (badge) badges.add(badge);
    });

    badges.forEach(sync);
  });

  function start() {
    syncAll(document);
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden']
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();